module OnlineDPR.Application.Client.DprInput

open Elmish
open Fable.React
open Fable.React.Props

open OnlineDPR.Application.Client
open OnlineDPR.Application.Client.Components
open OnlineDPR.Application.Client.Template
open OnlineDPR.Application.Shared
open OnlineDPR.Application.Shared.Translations
open OnlineDPR.Application.Shared.DateHandling

type Msg =
| FormSubmitted
| FieldChanged of Field
| PostedDataForDay of Result<SubmitedDprResult, string>
| CloseModalClicked

let logger = Jsnlog.GetLoggerWithName "DprInput"

let init template =
    DprInputModel { Date = {Year=1970; Month= 1; Day =1}
                    Fields = []
                    ClubId = 0
                    ClubNumber = ""
                    SubmitErrors = false
                    DisplayModal = false
                    GeneralErrors = []
                    Template = template }, []

let postDataForDayCmd (model:DprInputModel) =
    Cmd.OfPromise.either
                  (Http.postData APIUrls.PostSiteData)
                  model
                  PostedDataForDay
                  (Http.toErrorMessage >> PostedDataForDay)

let rec validateFields rows =
    match rows with
    | FieldWithLevel (l,f)::rest -> FieldWithLevel (l, validateField f) :: (validateFields rest)
    | r::rest -> r :: (validateFields rest)
    | [] -> []

let rec replaceFieldsWithError fields errorFields =
    match errorFields with
    | fe::rest -> let replaced = ListHelper.replace (fun x -> match x with
                                                              | FieldWithLevel (_,f) -> f.Key = fe.Key
                                                              | _ -> false)
                                                    (fun row -> match row with
                                                                | FieldWithLevel (l,_) ->  FieldWithLevel (l,fe)
                                                                | _ -> row)
                                                    fields
                  match replaced with
                   | Some fs -> replaceFieldsWithError fs rest
                   | None -> replaceFieldsWithError fields rest
    | [] -> fields

let update msg model =
    match msg with
    | FormSubmitted ->
        let model = { model with Fields = (validateFields model.Fields) }
        let validationMessage = List.tryFind (fun x -> match x with
                                                        | FieldWithLevel (_,f) -> Option.isSome f.ValidationMessage
                                                        | _ -> false ) model.Fields
        match validationMessage with
        | Some _ -> model, []
        | None -> model, (postDataForDayCmd model)
    | FieldChanged field ->
        let field = validateField field
        let fields = ListHelper.replace (fun x -> match x with
                                                  | FieldWithLevel (_,f) -> f.Key = field.Key
                                                  | _ -> false)
                                        ( fun row -> match row with
                                                       | FieldWithLevel (l,_) ->  FieldWithLevel (l,field)
                                                       | _ -> row)
                                        model.Fields
        match fields with
        | Some xs -> {model with Fields = xs }, []
        | None -> model, []
    | PostedDataForDay result ->
        match result with
        | Ok (DprInputServerValidationResult v) ->
            let fields = replaceFieldsWithError model.Fields v.FieldsWithErrors
            let hasGeneralErrors = (List.length v.GeneralErrors) > 0
            let hasSpecificErrors = (List.length v.FieldsWithErrors) > 0
            { model with
                 SubmitErrors = hasSpecificErrors
                 Fields = fields
                 GeneralErrors = v.GeneralErrors
                 DisplayModal = hasGeneralErrors }, []
         | Ok (Redirect r) ->
             Browser.Dom.window.location.href <- r.Url
             model, []
        | Error s ->
            logger.error s
            //Browser.Dom.window.location.href <- PageUrls.error CustomErrorCodes.DprInputError
            model, []
    | CloseModalClicked -> { model with DisplayModal = false }, []

let heading level key =
    div [ Class (sprintf "heading-level-%i" level) ]
        [ span []
               [str CurrentTranslations.Translations.[key] ]]

let calculatedField level key =
    div [ Class (sprintf "field-level-%i" level)]
        [ div [ Class "form-group row" ]
              [ label [ Class "control-label col-form-label col-sm-3" ]
                      [ str CurrentTranslations.Translations.[key] ]
                div [ Class "col" ]
                    [ div [ Class "input-group text" ]
                          [ str CurrentTranslations.Translations.[TranslationKey.DprNonOnfitUserInputMask_CalculatedField]]]]]

let errorIndicator m =
    match m.SubmitErrors with
    | true -> span [ Class "form-has-error" ] [str CurrentTranslations.Translations.[TranslationKey.DprNonOnfitUserInputMask_ErrorsInForm]]
    | false -> ofList []

let modal model dispatch =
    if model.DisplayModal then
        let title = CurrentTranslations.Translations.[TranslationKey.DprNonOnfitUserInputMask_GeneralErrorsModal_Title]
        Components.modal {Id = "Errors"; Title = title; Close = (fun () -> dispatch CloseModalClicked) }
            [
                h5 [] [ str CurrentTranslations.Translations.[TranslationKey.DprNonOnfitUserInputMask_GeneralErrorsModal_Text] ]
                ul [] (List.map (fun e -> li [] [ str (validationMessage e)] ) model.GeneralErrors)
            ]
    else
        ofList []

let viewInTemplate (model:DprInputModel) dispatch =
    let now = DayDateToGermanDate model.Date

    article [   Class "content" ]
            [   section [ Class "section" ]
                        [ div [ Class "card" ]
                              [ div [ Class "card-block" ]
                                    [ p [ ] [ str(sprintf "Club %s - %s" model.ClubNumber now) ]
                                      form []
                                           [ yield model.Fields
                                                   |> List.map (fun r -> match r with
                                                                         | Heading (level, translationKey) -> heading level translationKey
                                                                         | CalculatedField (level, translationKey) -> calculatedField level translationKey
                                                                         | FieldWithLevel (level, f) -> let fieldChanged changedField = dispatch (FieldChanged changedField)
                                                                                                        div [ Class (sprintf "field-level-%i" level)]
                                                                                                            [FieldComponent f fieldChanged])
                                                   |> ofList
                                             yield div [ Class "form-group"] [ a [  OnClick (fun _ -> dispatch FormSubmitted)
                                                                                    Class "btn btn-primary"
                                                                                    Href "#"]
                                                                                 [ str (CurrentTranslations.Translations.[TranslationKey.DprNonOnfitUserInputMask_SubmitButtonText])]
                                                                               errorIndicator model ]]]]]
                modal model dispatch ]

let view (model:DprInputModel) dispatch =
    templateView model.Template [] [] (viewInTemplate model dispatch)

